import { Component } from '@angular/core';

@Component({
  selector: 'app-datenschutz-view',
  templateUrl: './datenschutz-view.component.html',
  styleUrls: ['./datenschutz-view.component.scss'],
  standalone: false
})
export class DatenschutzViewComponent { }
